import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { IconCheckmark, IconMinus } from "../icons";
import styles from "./checkbox.module.scss";
import { useControllableState } from "../../helpers/state/state-hooks";
import classNames from "classnames";

export interface CheckboxProps extends RadixCheckbox.CheckboxProps {
  indeterminate?: boolean;
  className?: string;
}

export const Checkbox = ({
  indeterminate = false,
  className,
  ...rest
}: CheckboxProps) => {
  const [checked, setChecked] = useControllableState({
    prop: indeterminate ? "indeterminate" : rest.checked,
    defaultProp: rest.defaultChecked ?? false,
    onChange: rest.onCheckedChange,
  });
  const checkboxClasses = classNames(className, styles.checkboxRoot);
  return (
    <div className={checkboxClasses}>
      <div className={styles.checkboxContainer}>
        <RadixCheckbox.Root
          {...rest}
          className={styles.checkboxIndicatorContainer}
          checked={checked}
          onCheckedChange={(e) => {
            setChecked(e);
            rest.onCheckedChange && rest.onCheckedChange(e === true);
          }}
        >
          <RadixCheckbox.Indicator className={styles.checkboxIndicator}>
            {checked === "indeterminate" && (
              <IconMinus
                color="white"
                width={10}
                height={10}
                className={styles.checkIcon}
              />
            )}
            {checked === true && (
              <IconCheckmark
                color="white"
                width={10}
                height={10}
                className={styles.checkIcon}
              />
            )}
          </RadixCheckbox.Indicator>
        </RadixCheckbox.Root>
      </div>
    </div>
  );
};
